<ng-container *ngIf="globalState$ | async as g">
  <div
    *ngIf="rowId && (field?.value || g.adminMode)"
    style="min-height: 100px; min-width: 100px"
    [style.background-color]="styles.backgroundColor"
    [innerHTML]="fieldValue"
  ></div>
  <div #wrapper></div>
</ng-container>
